import { createApi } from "./createApi";
import { NavigateFunction } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "./universalAPIErrorHandler";
import { useAppStore } from "../../appStore";

export const fetchGroupTrees = (
  navigate: NavigateFunction,
  groupType?: "patrol"
): Promise<any[]> => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    return fetchGroupTrees(navigate, groupType);
  };

  const setResults = (data: any) => {
    const results = data?.results;
    const list = Array.isArray(results) ? results : [];
    if (groupType === "patrol") {
      useAppStore.getState().setGroupTreesPatrolOnly(list);
    } else {
      useAppStore.getState().setGroupTrees(list);
    }
    return list;
  };

  if (groupType === "patrol") {
    return new Promise((resolve, reject) => {
      AxiosUI.get(`group/tree/?group_type=patrol`)
        .then((response: AxiosResponse) => {
          const list = setResults(response.data);
          resolve(list);
        })
        .catch((reason: AxiosError) => {
          setResults(null);
          universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
          reject(reason);
        });
    });
  }

  return new Promise((resolve, reject) => {
    AxiosUI.get(`group/tree/?group_type=connector&page_size=1000`)
      .then((response: AxiosResponse) => {
        const list = setResults(response.data);
        resolve(list);
      })
      .catch((reason: AxiosError) => {
        setResults(null);
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
        reject(reason);
      });
  });
};
